import { MenuItem } from '@mui/material'
import { RpcError } from '@protobuf-ts/runtime-rpc'
import { useAlert } from 'hooks/useAlert'
import { TaskValue } from 'lib/actions/task'
import React, { FC, useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useTicketActionTracker } from 'redux_toolkit/lib/TicketActionTracker'

type MarkProvisionErroredTaskDropdownOptionProps = {
    task: TaskValue
    close: () => void
}

export const MarkProvisionErroredDropdownOption: FC<MarkProvisionErroredTaskDropdownOptionProps> = ({ task, close }) => {
    const intl = useIntl()
    const toast = useAlert()
    const ticketActionTracker = useTicketActionTracker()

    const handleClick = useCallback(async (): Promise<void> => {
        try {
            await ticketActionTracker?.markProvisionErrored(task)
        } catch (err) {
            toast(
                intl.formatMessage(
                    {
                        id: 'task_mark_provision_errored_error',
                        defaultMessage: 'Error marking provision won\'t do on task. {code}: {msg}',
                    },
                    {
                        code: (err as RpcError).code,
                        msg: (err as RpcError).message,
                    },
                ),
                'error',
            )
        }

        close()
    }, [close, intl, task, ticketActionTracker, toast])

    return (
        <MenuItem onClick={handleClick} key={`components_task_actions_dropdown_MarkProvisionErrored_task_${task.id}`}>
            {task.type && task.type.taskType.oneofKind === 'grant' ? (
                <FormattedMessage id="components_task_actions_dropdown_MarkProvisionErrored_task" defaultMessage="Won't provision" />
            ) : (
                <FormattedMessage id="components_task_actions_dropdown_MarkProvisionErrored_task" defaultMessage="Won't deprovision" />
            )}
        </MenuItem>
    )
}
